// Always name keys with uppercase snake_casing
// Always use keys for data storage

export const recipientTypeLabels = {
  VETERAN: 'Veteran',
  SPOUSE: 'Veteran’s spouse',
  CHILD: 'Veteran’s child',
  OTHER: 'Other',
};

export const travelLocationLabels = {
  HOSPITAL: 'Hospital',
  CLINIC: 'Clinic',
  PHARMACY: 'Pharmacy',
  OTHER: 'Other',
};

export const careTypeLabels = {
  RESIDENTIAL: 'Residential care facility',
  IN_HOME_CARE_ATTENDANT: 'In-home care attendant',
};

export const careFrequencyLabels = {
  ONCE_MONTH: 'Once a month',
  ONCE_YEAR: 'Once a year',
  ONE_TIME: 'One-time',
};

export const medicalExpenseTypeLabels = {
  ADAPTIVE_MEDICAL_EQUIPMENT: { label: 'Adaptive medical equipment' },
  AMBULANCE: { label: 'Ambulance' },
  DENTAL_COPAYS_AND_FEES: { label: 'Dental copays and fees' },
  DENTURES: { label: 'Dentures' },
  HEARING_AIDS_AND_BATTERIES: { label: 'Hearing aids and batteries' },
  HOSPITAL_COPAYS_AND_FEES: { label: 'Hospital copays and fees' },
  INCONTINENCE_SUPPLIES: { label: 'Incontinence supplies' },
  LONG_TERM_CARE_INSURANCE: { label: 'Long-term care insurance' },
  MEDICAL_COPAYS_AND_FEES: { label: 'Medical copays and fees' },
  MEDICAL_SUPPLIES: { label: 'Medical supplies' },
  MEDICARE_PART_B: { label: 'Medicare Part B' },
  MEDICARE_PART_C: { label: 'Medicare Part C' },
  MEDICARE_PART_D: { label: 'Medicare Part D' },
  OVER_THE_COUNTER_MEDICATION: { label: 'Over-the-counter medication' },
  PRESCRIPTION_MEDICATION: { label: 'Prescription medication' },
  PRIVATE_MEDICAL_INSURANCE_PREMIUMS: {
    label: 'Private medical insurance premiums',
  },
  VISION_CARE_COPAYS_AND_FEES: { label: 'Vision care copays and fees' },
  VITAMIN_FOOD_SUPPLEMENTS_AND_HERBAL_REMEDIES: {
    label: 'Vitamin, food supplements, and herbal remedies',
  },
};
